/**
 * 教程挂件
 */
import * as React from 'react'
import { useTranslation } from '@/libs/next-lang'
import { IconSvg } from '@/components'

export default function Widget({ label, onShow }) {
  const { t } = useTranslation(['components'])

  return (
    <div className="works" onClick={onShow}>
      <IconSvg className="icon" type="icon-jiaocheng-2" />
      <div className="txt">{label || t('components:t104')}</div>
    </div>
  )
}
